import axios from 'axios'
import { Message } from 'element-ui'
import { orderApi, url } from '@/settings.js'
const defaultSettings = require('../settings.js')
axios.defaults.withCredentials = true
axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.post['Content-Type'] = 'application/json'
// axios.defaults.baseURL = process.env.NODE_ENV == 'development' ? '/api' : '/API/api'
axios.interceptors.request.use(
	config => {
		if (localStorage.getItem('token')) {
			config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('token')
		}
		if ((config.params && config.params.order) || (config.data && config.data.order)) {
			config.baseURL = orderApi
			console.log('config', config.baseURL + config.url);
		} else {
			config.baseURL = url
		}
		return config
	},
	error => {
		// do something with request error
		console.log(error) // for debug
		return Promise.reject(error)
	}
)
axios.interceptors.response.use(res => {
	// console.log('---------response----------', res);
	if ((res.config.params && res.config.params.order) || (res.config.data && res.config.data.order)) {
		const data = res.data
		if (data.success) {
			return data
		} else {
			Message.error(data.message || data.msg || data.Message)
		}
	} else {
		let result = res.data
		if (typeof res.data === 'string') {
			result = JSON.parse(res.data);
		}
		if (result && result.IsSuccess) {
			localStorage.setItem('token', result.Token)
			//修改url参数
			let newUrl = updateQueryParam('token', result.Token); // 更新foo参数
			history.pushState({}, '', newUrl); // 不刷新页面改变URL
			let Data = typeof result.Data === "string" ? JSON.parse(result.Data) : result.Data;
			return Data
		} else {
			// var code = result.ErrorCode;
			Message.error(result.ErrorMsg)
			// ElMessage.error(result.ErrorMsg)
		}
	}
})

function updateQueryParam(param, newValue) {
    // 获取当前URL
    let url = window.location.href;
    // 正则表达式匹配参数
    let regex = new RegExp('([?&])' + param + '=.*?(&|$)');
    let separator = url.indexOf('?') !== -1 ? '&' : '?';
    // 如果URL中已有该参数，则更新它
    if (regex.test(url)) {
        return url.replace(regex, '$1' + param + '=' + newValue + '$2');
    } else {
        // 如果没有，则添加它
        return url + separator + param + '=' + newValue;
    }
}
export default axios
